import React, { PropsWithChildren } from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { type ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";

import { ScrollButton } from "./ScrollButton";

export interface ScrollButtonsProps {
  theme: ModuleThemeType;
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
}

/**
 * Scroll Buttons gives you a row with two arrow buttons that can control a left/right transition.
 * @param children will be placed between the two buttons.
 * @returns
 */
export const ScrollButtons: React.FC<PropsWithChildren<ScrollButtonsProps>> = ({
  theme,
  canScrollLeft,
  canScrollRight,
  onScrollLeft,
  onScrollRight,
  children,
}) => {
  return (
    <Container
      direction={{
        LRG: "row",
        MED: "row",
        SML: "column",
      }}
      alignItems="center"
      justifyContent={{
        LRG: "flex-start",
        MED: "flex-start",
        SML: "center",
      }}
      gap={{ LRG: "sml", SML: "none" }}
    >
      <Container
        alignItems="center"
        gap="sml"
        margin={{ SML: [0, 0, "sml", 0] }}
      >
        <ScrollButton
          moduleTheme={theme}
          orientation="left"
          onClick={onScrollLeft}
          canScroll={canScrollLeft}
        />
        {children}
        <ScrollButton
          moduleTheme={theme}
          orientation="right"
          onClick={onScrollRight}
          canScroll={canScrollRight}
        />
      </Container>
    </Container>
  );
};
